import { Image as ImageIcon } from 'lucide-react';
import { HeatmapCanvas } from './heatmap-canvas';
import type { HeatmapPoint } from '@/lib/heatmap-render';

interface Props {
  points: HeatmapPoint[];
  url: string;
  width?: number;
  height?: number;
}

export function HeatmapStage({ points, url, width = 1200, height = 800 }: Props) {
  return (
    <div
      className="relative w-full rounded-lg border border-border bg-bg-surface-2 overflow-hidden"
      style={{ aspectRatio: `${width} / ${height}` }}
    >
      {/* Grid background as screenshot placeholder */}
      <div
        className="absolute inset-0 opacity-30"
        style={{
          backgroundImage:
            'linear-gradient(var(--border) 1px, transparent 1px), linear-gradient(90deg, var(--border) 1px, transparent 1px)',
          backgroundSize: '32px 32px',
        }}
      />
      <div className="absolute inset-6 rounded border border-border-strong bg-bg-surface-3 flex flex-col items-center justify-center gap-2 text-text-subtle text-xs">
        <ImageIcon className="size-12 opacity-40" />
        <div>Screenshot of <span className="font-mono">{url}</span></div>
        <div className="text-[11px]">Heatmap overlay rendered above</div>
      </div>
      <HeatmapCanvas
        points={points}
        width={width}
        height={height}
        className="absolute inset-0 w-full h-full pointer-events-none mix-blend-screen"
      />
    </div>
  );
}
